import {
  type CSSProperties,
} from "react";
import { ModuleHeader } from "../../../../shared/components/ModuleHeader";
import { RequestComposer } from "./RequestComposer";
import { RequestQueue } from "./RequestQueue";
import { RequestWorkspace } from "./RequestWorkspace";
import { useRequestsWorkspace, type RequestsModuleProps } from "./useRequestsWorkspace";

export function RequestsModule(props: RequestsModuleProps) {
  const model = useRequestsWorkspace(props);
  const {
    user,
    statusFilter,
    setStatusFilter,
    rows,
    stageOptions,
  } = model;
  return (<>
    <ModuleHeader
      compact
      eyebrow="Talep yönetimi"
      title={
        user.role === "PLANLAMA"
          ? "Satın Alma Taleplerim"
          : "Satın Alma Talepleri"
      }
      description={
        user.role === "PLANLAMA"
          ? "İhtiyaç taleplerinizi oluşturun; talebin kimde olduğunu ve sıradaki adımı izleyin."
          : "İhtiyaçları kaydedin, teklif sürecini ve sorumluları tek ekrandan izleyin."
      }
    />
    {user.role !== "PLANLAMA" ? (
      <section
        className="workflow-status-filter"
        style={
          {
            "--workflow-filter-columns": stageOptions.length,
          } as CSSProperties
        }
        aria-label="Talep durumları"
      >
        {stageOptions.map((option) => {
          const count = rows.filter(option.matches).length;
          return (
            <button
              key={option.id}
              className={statusFilter === option.id ? "is-active" : ""}
              aria-pressed={statusFilter === option.id}
              onClick={() => setStatusFilter(option.id)}
            >
              <span>{option.label}</span>
              <strong>{count}</strong>
            </button>
          );
        })}
      </section>
    ) : null}
    <RequestComposer model={model} />
    <RequestQueue model={model} />
    <RequestWorkspace model={model} />
  </>);
}
